import React from "react";

const AttendanceShortCard = ({
  image,
  name,
  profileId,
  designation,
  percentage,
}) => {
  return (
    <tr>
      <td className="flex-row align-center justify-start g-05">
        {/* <div
          className="flex align-center justify-center"
          style={{
            width: "2rem",
            height: "2rem",
          }}
        > */}
          <img
            src={image}
            alt=""
            style={{
              width: "2rem",
              height: "2rem",
              objectFit: "cover",
              borderRadius: "50%",
            }}
            // className="h-full w-full"
          />
        {/* </div> */}
        <div className="flex-col" style={{ gap: "3px" }}>
          <p className="t-13 color-black w-full poppins line-height-1">
            {name}
          </p>
          <p
            className="t-10 color-grayColor w-full poppins"
            style={{ textWrap: "nowrap" }}
          >
            ID: {profileId}
          </p>
        </div>
      </td>
      <td className="t-10 text-align-end flex-1">{designation}</td>
    </tr>
  );
};

export default AttendanceShortCard;
